import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "./deptBlockPeople.scss";
import "./deptBlockPeopleGrid.scss";

const GridDepartmentBlockPeopleList = ({title, fieldDepartmentPeoples, handleShowDetails}) => {
  return (
    <div className="container general-container">
      {Boolean(title) && <h2 className="dept-people-header">{title}</h2>}
      <div className="row">
        {fieldDepartmentPeoples?.map((item, index) => (
          <div
            key={index}
            className="col-lg-4 col-md-6 col-sm-12"
          >
            <div className="dept-people-card-grid">
              {item?.relationships?.field_department_people_icon ? (
                <>
                  <GatsbyImage
                    className="dept-people-card-grid-img"
                    image={getImage(
                      item?.relationships?.field_department_people_icon
                        ?.gatsbyImage
                    )}
                    alt={title}
                  />
                </>
              ) : (
                <div className="dept-image-wrapper dept-image-wrapper-default dept-people-card-grid-img bg-clr-lightgrey ">
                  <img src="/images/avatar.png" alt="avatar" />
                </div>
              )}
              <div className="dept-people-card-grid-info">
                <h5 className="dept-people-card-grid-title">
                  {item?.field_department_people_name}
                </h5>
                <p className="dept-people-card-grid-subtitle">
                  {item?.field_department_people_title}
                </p>

                <span
                  role="button"
                  tabIndex={0}
                  className="dept-people-btn-icon-grid"
                  onClick={(ev) => handleShowDetails(ev, item)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === "Space") {
                      handleShowDetails(event, item);
                    }
                  }}
                >
                    Bio
                  </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridDepartmentBlockPeopleList